import { useQuery } from '@tanstack/react-query';
import { getPageData } from 'utils/lib/strapi';

const useGetCampaignPageCMSData = ({ slug }) => {
  const { data } = useQuery({
    queryKey: ['campaignPageCMSData', slug],
    queryFn: () =>
      getPageData({
        type: 'campaign-pages',
        slug,
      }),
    staleTime: 5 * 60 * 1000, // 5 minutes - data is prefetched from server
    refetchOnMount: false,
  });

  const hideTerms = data?.attributes?.hide_terms;

  return {
    hideTerms,
  };
};

export default useGetCampaignPageCMSData;
